<template>
  <div class="confirmation-form" v-if="formDescriptors.length">
    <div class="columns is-multiline">
      <div class="column is-12">
        <title-component
          :size="3"
          :lineSeparator="'under'"
          v-translate>
          Please choose a password
        </title-component>
        <template v-if="formDescriptors && formDatas">
          <form-component
            v-for="formDescriptor in formDescriptors"
            :formDescriptor="formDescriptor"
            :formData="getFormDataForDescriptor(formDescriptor)"
            :key="formDescriptor.id">
          </form-component>
        </template>
        <transition
          name="fade"
          appear
          appear-active-class="animated fadeIn"
          enter-active-class="animated fadeIn"
          leave-active-class="animated fadeOut"
          :duration="{ enter: 200, leave: 200 }">
          <div v-if="mixin.error" class="notification is-danger">
            {{ mixin.error }}
          </div>
        </transition>
        <!-- Buttons -->
        <div class="field">
          <p class="control">
            <submit-btn-component
              class="is-primary"
              ref="enterButton"
              @submit="confirmPassword"
              v-translate>
              Submit
            </submit-btn-component>
          </p>
        </div>
      </div>
    </div>
  </div>

</template>
<script>
  import { mapActions, mapMutations, mapState } from 'vuex'
  import FormComponent from '../form/FormComponent'
  import { API_APPS } from '@/api/config'
  import TitleComponent from '../layout/TitleComponent.vue'
  import SubmitBtnComponent from '@/components/layout/utility/SubmitBtnComponent.vue'
  import { onKeyEnterMixin, formHandlerMixin } from '@/mixins/mixins'
  import Status from '@/classes/http/Status'

  export default {
    name: 'confirmation-form-component',
    mixins: [onKeyEnterMixin, formHandlerMixin],
    data () {
      return {
      }
    },
    props: {
      code: {
        type: String,
        required: true
      }
    },
    components: {
      TitleComponent,
      FormComponent,
      SubmitBtnComponent
    },
    computed: {
      ...mapState({
        formDescriptors: state => state.formModule.formDescriptors,
        formDatas: state => state.formModule.formDatas,
        authUser: state => state.authModule.authUser
      })
    },
    methods: {
      ...mapMutations([
        'setAuthUser'
      ]),
      ...mapActions([
        'setupConfirmationForm',
        'saveConfirmationForm',
        'infoMessage',
        'clearData'
      ]),
      confirmPassword (btn) {
        let requestData = {
          formDatas: this.formDatas,
          code: this.code
        }
        this.submitRequest = this.saveConfirmationForm
        this.submitForm(requestData, btn, this.confirmPasswordCallback)
      },
      confirmPasswordCallback (response) {
        this.setAuthUser(response.data)
        if (this.authUser.isCustomer()) {
          window.location.replace(API_APPS.CUSTOMER + '/')
        }
        if (this.authUser.isHR()) {
          window.location.replace(API_APPS.HR + '/')
        }
      }
    },
    created () {
      this.setupConfirmationForm(this.code).catch((err) => {
        if (err.response && err.response.status === Status.NOT_FOUND) {
          this.infoMessage('You have already confirmed.')
          this.$router.push({ name: 'LoginView' })
        } else {
          this.handleError(err)
        }
      })
    },
    beforeDestroy () {
      this.clearData()
    }
  }
</script>
